import { requestGet as wsRequestGet } from "./_wsApiFetchData";

export async function searchAutomatedBookingAgreements(
  options,
  language,
  timeZone,
  cancelToken
) {
  const { filters } = options;
  const {
    orderBy,
    orderDirection,
    page,
    resultsPerPage,
    id,
    facilityId,
    productId,
    user,
    status,
    dayOfWeek,
    preferredCourtName,
    createdFrom,
    createdTo,
    activeFrom,
    activeTo,
  } = filters;

  const params = {
    OrderBy: orderBy || "createdAt",
    OrderDirection: orderDirection || "desc",
    Page: page || 1,
    ResultsPerPage: resultsPerPage || 20,
    Id: id || undefined,
    FacilityId: facilityId || undefined,
    ProductId: productId || undefined,
    User: user || undefined,
    Status: status || undefined,
    DayOfWeek: dayOfWeek || undefined,
    PreferredCourtName: preferredCourtName || undefined,
    CreatedFrom: createdFrom || undefined,
    CreatedTo: createdTo || undefined,
    ActiveFrom: activeFrom || undefined,
    ActiveTo: activeTo || undefined,
  };

  return wsRequestGet(
    "/admin/AutomatedBookingAgreements/search",
    language,
    timeZone,
    params,
    cancelToken
  );
}

export async function getAgreementById(
  agreementId,
  language,
  timeZone,
  cancelToken
) {
  return wsRequestGet(
    `/admin/AutomatedBookingAgreements/${agreementId}`,
    language,
    timeZone,
    null,
    cancelToken
  );
}

export async function getUserAgreementCount(
  userId,
  language,
  timeZone,
  cancelToken
) {
  return wsRequestGet(
    `/admin/AutomatedBookingAgreements/count/${userId}`,
    language,
    timeZone,
    null,
    cancelToken
  );
}
